<template>
  <div class="assignment" v-if="assignment" :key="assignment.assignment_id">
    <div
      class="assignment-deleted-on-remote flex flex-align"
      v-if="!assignment.assignment_exists_on_remote"
    >
      <div class="ff center">
        This assignment no longer exists in the LMS and any work that you do may not be saved.
      </div>
    </div>
    <div class="assignment-container flex">
      <main class="ff flex flex-center">
        <div class="assignment-constraint">
          <header>
            <router-link class="wordmark" :to="{ name: 'product.contents' }">
              <img src="@/assets/logo.svg" class="logo" />
            </router-link>
            <h1>{{ assignment.assignment_title }}</h1>
          </header>
          <article>
            <template v-for="child of assignment.component_children">
              <components
                v-if="child.component_type !== 'string'"
                :configuration="child"
                v-bind="child.component_data"
                :id="child.component_id"
                :key="child.component_id"
              />
              <template v-else>{{ child.component_content.trim() }}</template>
            </template>
          </article>
          <footer>
            <div class="assignment-submit">
              <div
                class="button"
                @click="check"
                :class="{ disabled: assignment.submission_state !== 'started' }"
              >
                Submit Assignment
              </div>
            </div>
            <div class="disclaimer center">
              Download the text for free at
              <a target="_blank" :href="product.product_source_url">OpenStax</a>.
            </div>
          </footer>
        </div>
      </main>
      <div
        class="assignment-simulation"
        v-if="assignment.chapter_simulation"
        :key="assignment.assignment_id"
        :style="backgroundImage()"
      >
        <simulation ref="simulation" :root="true" v-show="!isAnatomy || activeSimulation" />
      </div>
    </div>
  </div>
</template>

<script>
import Options from "@/components/modals/Options.vue";

export default {
  name: "Assignment",
  data() {
    return {};
  },
  methods: {
    check() {
      for (const question of this.$store.state.assignments.questions.values()) {
        if (question.attempts.length === 0) {
          //Show the user an alert.
          const _this = this;

          return this.$modal.show(
            Options,
            {
              title:
                "You have one or more unanswered questions. Are you sure you want to submit this assignment?",
              options: [
                {
                  title: "Go Back",
                  fn() {},
                },
              ],
            },
            {
              width: 260,
              height: "auto",
              classes: "modal",
            }
          );
        }
      }

      this.submit();
    },
    submit() {
      //Check to see if there are any questions that are unanswered.
      this.$store
        .dispatch("assignments/submit")
        .then(() => this.$toasted.success("Your assignment has been submitted."))
        .catch((error) => {
          console.log(error);
          this.$toasted.error("There was an error submitting your assignment.");
        });
    },
    backgroundImage() {
      let bgImageStyle = null;
      const splashImagePath = "/assets/0376b7fc-4f04-4406-a58c-996c87ece1a8/splash-screen-renders";

      if (this.assignment.chapter_simulation && this.isAnatomy) {
        const chapter = this.assignment.chapter_number.match("^([^.]+)");
        const imagePath = `${splashImagePath}/Ch${chapter[0]}_render.png`;
        bgImageStyle = {
          backgroundImage: `url(${imagePath})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover",
          transition: "background-image .5s linear",
        };
      }

      return bgImageStyle;
    },
  },
  computed: {
    product() {
      return this.$store.getters.product;
    },
    assignment() {
      return this.$store.getters.assignment;
    },
    user() {
      return this.$store.state.user;
    },
    active() {
      return this.$route.params.assignment;
    },
    isAnatomy() {
      return this.product.product_id === "0376b7fc-4f04-4406-a58c-996c87ece1a8";
    },
    activeSimulation() {
      return this.$store.state.chapters.simulation;
    },
  },
  created() {
    const product = this.$store.getters.products.find(
      (product) => product.product_slug === this.$route.params.product
    );

    if (product) {
      this.$store
        .dispatch("products/activate", product)
        .then(() =>
          this.$store.dispatch("assignments/load", {
            product_id: this.product.product_id,
            assignment_id: this.active,
          })
        )
        .catch(() => this.$toasted.error("There was an error loading the requested assignment."));
    }
  },
  destroyed() {
    this.$store.dispatch("chapters/simulation", {
      simulation: null,
    });
  },
};
</script>

<style scoped lang="less">
@import "~@/assets/less/variables";

.assignment,
&.assignment-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

main {
  min-width: 450px;
  overflow-y: auto;
}

.assignment-constraint {
  max-width: 800px;
  width: 100%;
}

header {
  padding: 50px 50px 0;
  margin-bottom: 20px;

  .wordmark {
    font-size: 18px;
    font-weight: 500;

    .logo {
      width: 80px;
    }
  }

  h1 {
    margin: 30px 50px 0 0;
    font-size: 36px;
    line-height: 44px;
  }

  h2 {
    margin-top: 20px;
    font-weight: 500;
    word-wrap: break-word;
    color: var(--secondary-text-color);
    line-height: 24px;
  }

  hr {
    margin: 50px 0 0;
    height: 1px;
    border: 0;
    background: #333;
  }
}

.assignment-simulation {
  flex: 2;
  background: #111;
  border-left: 1px solid var(--border-color);
}

.assignment-submit {
  margin: 50px;
}

.disclaimer {
  margin: 50px;
  font-size: 12px;
  color: var(--secondary-text-color);

  a {
    color: @base;
  }
}

.assignment-deleted-on-remote {
  height: 48px;
  background: @red;
  color: @f;
  font-weight: 500;
  font-size: 14px;
  padding: 0 20px;

  .constrain {
    height: 100%;
  }

  .text-button.border {
    font-size: 12px;
    padding: 2px 10px;
    margin-left: 10px;

    &:hover,
    &:active {
      background: transparent;
    }
  }
}

@media only screen and (max-width: 1100px) {
  main {
    min-width: 400px;
  }
}
</style>
